import * as S from "./styles";

import { Typography } from "@material-ui/core";
import { useHistory, withRouter } from "react-router-dom";
import Attention from "../../assets/img/attention.png";
import Gif from "../../assets/img/bookingError.png";
import ThemeButton from "../../components/ThemeButton";

import { getSessionStorage } from "../../utils/getSessionStorage";

function BookingError({ type, searchState, buscaAtual }) {
  let history = useHistory();
  const bookingError = getSessionStorage("@bookingError");
  const reprocessar = getSessionStorage("reprocessar");
  const isInconsistent = bookingError.includes(
    "Sua reserva foi realizada e esta em análise"
  );
  return (
    <S.Wrapper>
      <img src={isInconsistent ? Attention : Gif} alt="Compra concluida" />
      <Typography variant="h5">
        {isInconsistent ? "Reserva em análise" : "Erro ao realizar reserva!"}
      </Typography>
      <Typography variant="span" color="error">
        {bookingError}
      </Typography>

      <ThemeButton
        onClick={() => {
          reprocessar
            ? history.push("/conta/minhas-viagens")
            : history.push("/busca/resumo");
        }}
        className="pesquisa"
      >
        Tentar novamente
      </ThemeButton>
    </S.Wrapper>
  );
}

export default withRouter(BookingError);
